import { DefaultButton } from "@fluentui/react/lib/Button";
import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";

interface Props {
  text: string;
  disabled?: boolean;
  checked?: boolean;
  onClick?: () => any;
  baseTypeProps?: any;
}

const CancelButton = (props: Props) => {
  return (
    <>
      <DefaultButton
        text={props.text}
        onClick={props.onClick}
        disabled={props.disabled}
        checked={props.checked}
        {...props.baseTypeProps}
      >
        <Icon iconName="Cancel" />
      </DefaultButton>
    </>
  );
};

export default CancelButton;
